import { TFunction } from '@mint-lib/i18n';
import { z } from 'zod';

export const getCreateActivityValidationSchema = (t: TFunction) =>
  z.object({
    name: z
      .string()
      .min(1, t('Fields marked with (*) are required'))
      .max(255, t('Name should have at most 255 characters')),
    date: z.object({
      from: z.date({
        error: t('Fields marked with (*) are required'),
      }),
      to: z.date({
        error: t('Fields marked with (*) are required'),
      }),
    }),
    budget: z.number().min(0, t('Budget cannot be less than 0')).nullable(),
  });

export type CreateActivityData = z.infer<
  ReturnType<typeof getCreateActivityValidationSchema>
>;
